import React from 'react';
import useSearch from '../../../../context/search/useSearch';

interface Props {
  showClear?: boolean
  showApply?: boolean
  filterIndexToClear?: number,
  afterApply?: () => void
  afterClear?: () => void
}

const ClearAndApplyButton: React.FC<Props> = ({ showClear, showApply, filterIndexToClear, afterApply, afterClear }) => {
  const { inputEventHandlers, pendingProductCount, filtersChanged, setFiltersChanged, hasActiveFilters } = useSearch()

  return (
    <>
      { showClear ?
        <button
          type="button"
          disabled={!hasActiveFilters}
          className='btn btn-2 btn--block clear-close no-hover'
          onClick={() => {
            if (!hasActiveFilters) return
            if (typeof filterIndexToClear === 'number') {
              inputEventHandlers.handleClearSpecificFilter(filterIndexToClear);
            }
            setFiltersChanged(false);
            afterClear && afterClear();
          }
          }>Clear</button>
        : ''}
      { showApply ?
        <button
          type='button'
          disabled={!filtersChanged || !pendingProductCount}
          className='btn btn--block apply-close no-hover'
          onClick={() => {
            if (!filtersChanged) return
            inputEventHandlers.handleApply()
            setFiltersChanged(false);
            afterApply && afterApply();
          }
          }>Apply{pendingProductCount && !isNaN(pendingProductCount) && pendingProductCount > 0 ? ` (${pendingProductCount})` : '' }</button>
        : ''}

    </>
  )
}

export default ClearAndApplyButton